export default class newcolorManager {
    constructor() {

        //canvas
        this.canvas;
        this.context;
        this.startTime;
        this.fade;
        this.image;
        this.timer;
        this.start_ex = 0, this.start_dx = 620, this.end_ex = 0, this.end_dx = 620,
        this.currentParam;
        this.rcurrentParam;
        this.reverceFlg = false;

    }

    init() {

        this.color();

    }

    color(){

        this.fade = new Image();
        this.image = new Image();
        this.fade.src = '/assets/img/products/ricepot/new_color/fade2.png';
        this.image.src = '/assets/img/products/ricepot/new_color/img_main_white.png';

        this.image.onload = () => {
            this.canvas = document.getElementById('color-white');
            this.context = this.canvas.getContext('2d');
            this.context.globalCompositeOperation = 'source-out';
            this.startTime = new Date();
            this.timer = setInterval(() => {
                this.animation()
            }, 1000 / 100 );
        }


    }

    animation(){

        this.context.clearRect(0, 0, 554, 382);
        let now = new Date();
        if (this.reverceFlg) { //逆再生
            //console.log(currentParam);
            this.rcurrentParam = this.easing(now - this.startTime, this.end_ex, this.end_dx - this.end_ex, 1200);
            this.context.drawImage(this.fade, (this.currentParam - 820) + this.rcurrentParam, 0, 2000, 382);
            this.context.drawImage(this.image, 0, 0, 554, 382);
            if (now - this.startTime >= 1200) {
                this.reverceFlg = false;
                this.startTime = new Date();
                clearInterval(this.timer);
                setTimeout(() => {
                    this.startTime = new Date();
                    this.timer = setInterval(() => {
                        this.animation()
                    }, 1000 / 100 );
                }, 1500);
            }
        }else { //通常
            this.currentParam = this.easing(now - this.startTime, this.start_ex, this.start_dx - this.start_ex, 1200);
            this.context.drawImage(this.fade, this.currentParam - 1880, 0, 2000, 382);
            this.context.drawImage(this.image, 0, 0, 554, 382);
            if (now - this.startTime >= 1200) {
                clearInterval(this.timer);
                this.reverceFlg = true;
                this.startTime = new Date();
                clearInterval(this.timer);
                setTimeout(() => {
                    this.startTime = new Date();
                    this.timer = setInterval(() => {
                        this.animation()
                    }, 1000 / 100 );
                }, 1600);
            }
        }

    }

    easing(t, b, c, d) { //t=経過時間 b=開始時間 c=終了時間 d=所要時間
        if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
        return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
    }

}

